import { use } from 'react'

import { AuthContext } from '#providers/AuthProvider'
import type { IAuthContext } from '#providers/AuthProvider/interfaces'

export function useAuth(): IAuthContext {
  const context = use(AuthContext)
  if (!context) throw new Error('useAuth must be used within an AuthProvider')

  return context
}
